export default __webpack_public_path__ + "static/media/Almond-3_about.b4e6282f.webp";